import { render, staticRenderFns } from "./EnviarEmailCotacao.vue?vue&type=template&id=20f00c29&scoped=true"
import script from "./EnviarEmailCotacao.vue?vue&type=script&lang=js"
export * from "./EnviarEmailCotacao.vue?vue&type=script&lang=js"
import style0 from "./EnviarEmailCotacao.vue?vue&type=style&index=0&id=20f00c29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f00c29",
  null
  
)

export default component.exports